import RegionRepository from "../repository/RegionRepository";
import VehicleCategoryRepository from "../repository/VehicleCategoryRepository";
import ScheduleRepository from "../repository/ScheduleRepository";
import AuthRepository from "../repository/AuthRepository";
import OrderRepository from "../repository/OrderRepository";
import BankRepository from "../repository/BankRepository";

const repositories = {
    regions: RegionRepository,
    vehicle_categories: VehicleCategoryRepository,
    schedules: ScheduleRepository,
    auth: AuthRepository,
    orders: OrderRepository,
    bank: BankRepository
};

const RepositoryFactory = {
    get: name => repositories[name]
};

export { RepositoryFactory };
